<template>
<div id="lineas-captura-admin">
    <div>
        <v-breadcrumbs :items="breadcrumbs">
            <v-icon slot="divider">forward</v-icon>
        </v-breadcrumbs>
    </div>

    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Contribuciones" class="elevation-1 px-5 py-3">
                    <br>
                    <v-tabs grow style="margin-bottom: 30px;">
                        <v-tabs-slider color="primary"></v-tabs-slider>
                        <v-tab :key="'in-report'">Generar en Reporte</v-tab>
                        <v-tab :key="'in-layout'">Carga Layout</v-tab>
                        <v-tab-item :key="'in-report'">
                            <v-card-text>
                                <v-card-title>
                                    <span class="headline"></span>
                                </v-card-title>
                                <v-form ref="form" lazy-validation>
                                    <v-container grid-list-md text-xs-center>
                                        <v-row row wrap v-if="show_combo_rfc">
                                            <v-col sm="12" md="10" lg="10">
                                                <v-autocomplete v-model="model.rfc_cliente" :items="rfcs_array" :hide-no-data="true" label="RFC" :rules="[rules.required]">
                                                </v-autocomplete>
                                            </v-col>
                                        </v-row>
                                        <v-row row wrap>
                                            <v-col sm="12" md="10" lg="10">
                                                <v-autocomplete v-model="model.reporte_url" :items="
                        list_reportes" :hide-no-data="true" :return-object="false" item-text="reporte" item-value="url" label="Tipo de Reporte" @change="setNombreReporte()" :rules="[rules.required]">
                                                </v-autocomplete>
                                            </v-col>
                                        </v-row>

                                        <v-layout row wrap>
                                            <v-flex s12 m5 l5>
                                                <v-menu offset-x ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                    <template v-slot:activator="{ on }">
                                                        <v-text-field v-on="on" v-model="model.fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="model.fecha_de = parseDate(model.fecha_de)" v-mask="'####-##-##'" :rules="[verificaPedimento, validaAnio, validaFecha, $rules.validaDiasConsulta(model.fecha_de, model.fecha_a)]"></v-text-field>
                                                    </template>

                                                    <v-date-picker v-model="model.fecha_de" color="secondary" scrollable locale="es-mx" @input="menu1 = false">
                                                        <v-spacer />

                                                        <v-btn color="secondary" x-small @click="menu1 = false">
                                                            Cancelar
                                                        </v-btn>
                                                    </v-date-picker>
                                                </v-menu>
                                            </v-flex>
                                            <v-flex s12 m5 l5>
                                                <v-menu offset-x ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                    <template v-slot:activator="{ on }">
                                                        <v-text-field v-on="on" v-model="model.fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="model.fecha_a= parseDate(model.fecha_a)" v-mask="'####-##-##'" :rules="[verificaPedimento, validaAnio, validaFecha, $rules.validaDiasConsulta(model.fecha_de, model.fecha_a)]"></v-text-field>
                                                    </template>
                                                    <v-date-picker v-model="model.fecha_a" color="secondary" scrollable locale="es-mx" @input="menu2 = false">
                                                        <v-spacer />

                                                        <v-btn color="secondary" x-small @click="menu2 = false">
                                                            Cancelar
                                                        </v-btn>
                                                    </v-date-picker>
                                                </v-menu>
                                            </v-flex>
                                            <v-flex s12 m2 l2>
                                                <v-btn icon title="Pegar Listado" @click="dialog1 = !dialog1" v-tippy>
                                                    <v-icon colorHover="secondary" size="48">mdi-clipboard-list-outline</v-icon>
                                                </v-btn>
                                            </v-flex>
                                        </v-layout>
                                        <v-row row wrap>
                                            <v-col>
                                                Total de elementos en la lista: <strong>{{lista_filtrada.length}}</strong>
                                            </v-col>
                                        </v-row>
                                        <v-row row wrap>
                                            <v-col sm="12" md="10" lg="10">
                                                <v-combobox v-model="lista_filtrada" label="Lista de pedimentos" multiple persistent-hint small-chips disabled color="green">
                                                </v-combobox>
                                            </v-col>
                                        </v-row>

                                    </v-container>
                                </v-form>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>

                                <v-btn color="success" @click="generar_reporte_sqs">
                                    <v-icon>done</v-icon>Generar Reporte
                                </v-btn>
                            </v-card-actions>

                            <v-card-text>
                                <v-refresh-button :funcion="cargarReportesDS" />
                                <v-client-table ref="vuetable" :data="datos" :columns="columns" :options="options" class="elevation-2 pa-2">
                                    <template slot="noResults">
                                        <v-alert :value="true" icon="info" color="info">No se encontro ningun registro</v-alert>
                                    </template>

                                    <template slot="actions" slot-scope="props">
                                        <v-btn text icon color="primary" title="Descargar" v-if="props.row.estatus=='Generado Correctamente' && props.row.filename!='' " @click="downloadFile(props.row.filename)">
                                            <v-icon dark>get_app</v-icon>
                                        </v-btn>
                                        <v-btn text icon color="red" title="Eliminar" v-if="permisoEliminar" @click="eliminarReporte(props.row.id)">
                                            <v-icon dark>delete</v-icon>
                                        </v-btn>
                                    </template>
                                </v-client-table>
                            </v-card-text>

                        </v-tab-item>
                        <v-tab-item :key="'in-layout'">
                            <v-container fluid fill-height>
                                <v-layout align-center justify-center>
                                    <v-flex xs12>
                                        <v-card>
                                            <v-card-actions>

                                                <v-spacer></v-spacer>
                                                <v-speed-dial direction="left" open-on-hover>
                                                    <template v-slot:activator>
                                                        <v-btn x-small fab dark color="primary">
                                                            <v-icon>reorder</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <upload-excel-component :on-success="handleSuccess" :before-upload="beforeUpload" />
                                                    <v-btn x-small fab dark color="primary" title="Descargar Layout"  @click="download_layout('Layout_Contribuciones.xlsx')">
                                                            <v-icon dark>get_app</v-icon>
                                                        </v-btn>
                                                </v-speed-dial>

                                            </v-card-actions>

                                            <v-card-text>
                                                <div id="datagrid">
                                                    <v-refresh-button :funcion="cargarConsultas" />
                                                    <v-client-table ref="vuetable" :data="consulta.items" :columns="consulta.columns" :options="consulta.options" class="elevation-2 pa-2">
                                                        <template slot="noResults">
                                                            <v-alert :value="true" icon="info" color="info">No se encontró ningun registro</v-alert>
                                                        </template>

                                                        <template slot="actions" slot-scope="props">
                                                           
                                                            
                                                           <v-btn text icon color="primary" @click.native="downloadFile(props.row.key)" title="Descargar Archivo" v-tippy>
                                                               <v-icon>get_app</v-icon>
                                                          </v-btn>
                                                       
                                                       </template>
                                                    </v-client-table>
                                                </div>

                                            </v-card-text>
                                        </v-card>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-tab-item>
                    </v-tabs>

                    <!-- MODAL DETALLES -->
                    <v-dialog v-model="modal" max-width="80%" style=" z-index: 400 !important;">
                        <v-card>
                            <v-card-title>
                                <v-card class="primary white--text titulomodal">
                                    <v-icon class="white--text">list</v-icon>&nbsp;
                                    <span class="subheading">
                                        <strong>Detalle Contribuciones</strong>
                                    </span>
                                </v-card>
                                <v-spacer></v-spacer>
                                <v-btn icon @click.native="modal = false" class="close_modal">
                                    <v-icon class="white--text">cancel</v-icon>
                                </v-btn>
                            </v-card-title>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <exportar-excel :data="data_detalle" :exportFields="data_detalle_excel" name="Detalle_Lineas_Captura.xlsx">
                                    <v-btn dark small color="success" title="Exportar Detalle" v-tippy>
                                        <v-icon dark>get_app</v-icon> Exportar Detalle
                                    </v-btn>
                                </exportar-excel>
                            </v-card-actions>
                            <v-card-text>
                                <v-client-table ref="vuetabledetalle" :data="data_detalle" :columns="columns_detalle" :options="options_detalle" class="elevation-2 pa-2">
                                    <template slot="noResults">
                                        <v-alert :value="true" icon="info" color="info">No se encontro ningun registro</v-alert>
                                    </template>
                                    <template slot="localizado" slot-scope="props">
                                        <div class="columnaCriterio">
                                            {{ props.row.localizado }}
                                        </div>
                                    </template>
                                </v-client-table>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn @click.native="modal = false">
                                    <v-icon>cancel</v-icon>Cerrar
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>

                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>

    <v-dialog v-model="dialog1" max-width="500px">
        <v-card>
            <v-card-text>
                <h5>Ingrese lista de pedimentos</h5>
                <span>Uno por línea con formato: 000-0000-0000000</span><br>
                <small>*Usando esta opción no se tomará en cuenta el rango de fechas</small>
                <v-form ref="formListado" lazy-validation="">
                    <v-textarea outlined rows="15" v-model="model.lista" :rules="[rules.required, maxListaRule]"></v-textarea>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn small @click="model.lista=''; lista_filtrada=[]; dialog1 = false">Cancelar</v-btn>
                <v-btn small color="primary" @click="setListValues();">Buscar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Vue from "vue";
import GridLoader from "vue-spinner/src/GridLoader.vue";
import RefreshButton from "@/components/RefreshButton.vue";

export default {
    components: {
        "v-refresh-button": RefreshButton,
        loader: GridLoader
    },
    created: function () {
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        this.URL = this.$hostname + "reportes/";
        this.model.usuario = this.$local_storage.get("id_usuario");
        var tipoUsuario = this.$local_storage.get("tipo_usuario");
        if (tipoUsuario == "Soporte" || tipoUsuario == "Super Usuario") {
            this.permisoEliminar = true;
            this.model.rfc = "ADMINISTRACION";
            this.get_rfcs();
        } else {
            this.model.rfc = this.$local_storage.get("rfc");
        }

        this.cargarReportesDS();
        this.cargarConsultas();
    },
    data: () => ({
        rfcs_array: [],
        show_combo_rfc: false,
        dialog1: false,
        lista_filtrada: [],
        refreshTabla: false,
        permisoEliminar: false,
        fab: false,
        elzip: "",
        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/home"
            },
            {
                text: "Contribuciones",
                disabled: true,
                to: ""
            }
        ],
        datos: [],
        data_detalle: [],
        data_detalle_excel: {
            "RFC": "rfc",
            "Banco": "banco",
            "Línea Captura": "linea_captura",
            "Otras referencias": "otros",
            "Importe": "importe",
            "Fecha Cargo Edo Cuenta": "fecha",
            "Aduana": "aduana",
            "Patente": "patente",
            "Pedimento": "pedimento",
            "No. Operación Bancaria": "numero_operacion_bancaria",
            "No. Transacción SAT": "numero_transaccion_sat",
            "Pago Aplicado a Pedimento": "aplicado",
            "Pedimento Encontrado": "localizado"
        },
        columns_detalle: ["rfc", "banco", "linea_captura", "otros", "importe", "fecha", 'aduana', 'patente', 'pedimento',
            'numero_operacion_bancaria', 'numero_transaccion_sat', "aplicado", 'localizado'
        ],
        options_detalle: {
            headings: {
                "rfc": "RFC",
                "banco": "Banco",
                "linea_captura": "Línea Captura",
                "otros": "Otras referencias",
                "importe": "Importe",
                "fecha": "Fecha Cargo Edo Cuenta",
                "patente": "Patente",
                "pedimento": "Pedimento",
                "numero_operacion_bancaria": "No. Operación Bancaria",
                "numero_transaccion_sat": "No. Transacción SAT",
                "aplicado": "Pago Aplicado a Pedimento",
                "localizado": "Pedimento Encontrado"
            }
        },
        modal: false,
        validaContribucion: false,
        validaForma: false,
        validaIdentificador: false,
        arr_formas_pago: [],
        arr_contribuciones: [],

        columns: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error", "actions"],
        options: {
            filterable: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error"],
            sortable: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error"],

            headings: {
                id: "No. Proceso",
                fecha_solicitud: "Solicitado",
                usuario_email: "Usuario",
                nombre_reporte: "Reporte",
                criterio: "Criterio de Búsqueda",
                fecha_generacion: "Generado",
                estatus: "Estatus",
                error: "Error",
                actions: "Descargar"
            }
        },
        show_loading: true,

        list_reportes: [{
                "reporte": "Contribuciones Global",
                "url": "/reportes_ds/contribuciones_global/"
            },
            {
                "reporte": "Contribuciones Partidas",
                "url": "/reportes_ds/contribuciones_partidas/"
            },
        ],
        consulta: {
            columns: ["id", "fecha", "usuario_nombre", "estatus", 'errores' , 'actions'],
            options: {
                filterable: ["id", "fecha", "usuario_nombre", "estatus", 'errores'],
                sortable: ["id", "fecha", "usuario_nombre", "estatus", 'errores'],

                headings: {
                    id: "No. Proceso",
                    fecha_creacion: "Fecha Solicitud",
                    usuario_nombre: "Usuario",
                    estatus: "Estatus",
                    errores: "Errores",
                    actions: "Opciones"
                }
            },
            selected: [],
            camposexcel: {
                "Banco": "banco",
                "Referencia": "referencia",
                "Importe": "efectivo",
                "Fecha de Cargo": "fecha",
                "Estatus": "estatus"
            },
            items: [],
            //En el encabezado deben ser iguales los pares, respetando el nombre del campo definido en el modelo de la API
            encabezadoLayout: {
                rfc: "rfc",
                banco: "banco",
                linea: "linea",
                otros: "otros",
                importe: "importe",
                fecha: "fecha",
                aduana: "aduana",
                patente: "patente",
                pedimento: "pedimento",
                numero_operacion_bancaria: "numero_operacion_bancaria",
                numero_transaccion_sat: "numero_transaccion_sat",
            },
            //van vacíos para solo descargar layout con encabezados
            camposLayout: [{
                rfc: "[RFC]",
                banco: "[Banco]",
                linea: "[Línea de Captura 20 caracteres, ejemplo: 032001AJO6P127331222]",
                otros: "[Otras referencias de Pago]",
                importe: "[Importe]",
                fecha: "[Fecha de Cargo]",
                aduana: "[Numero de aduana 2 digitos]",
                patente: "[Número de Patente 4 dígitos]",
                pedimento: "[Número de Pedimento 7 dígitos]",
                numero_operacion_bancaria: "[Número operación bancaria - Opcional]",
                numero_transaccion_sat: "[Número Transaccion SAT - Opcional]",
            }]
        },
        model: {
            rfc: "",
            rfc_cliente: "",
            usuario: "",
            fecha_de: "",
            fecha_a: "",
            reporte_url: "",
            nombre_reporte: "",
            tipo: "Layout_Contribuciones",
            lista: '',
        },

        menu1: false,
        menu2: false,

        rules: {
            required: v => !!v || "Este campo es requerido",
            numeric: value => {
                const pattern = /^[\d]*$/;
                return pattern.test(value) || "Solo se permiten números";
            }
        }
    }),

    methods: {
        setListValues: function () {
            this.lista_filtrada = [];
            let to_list = this.get_array_lista(this.model.lista);
            for (var i = 0; i < to_list.length; i++) {
                if (this.lista_filtrada.includes(to_list[i])) {
                    continue;
                } else {
                    this.lista_filtrada.push(to_list[i]);
                }
            }
            this.model.fecha_de = "";
            this.model.fecha_a = "";
            this.dialog1 = !this.dialog1;
        },
        cargarConsultas: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
          
            axios.post( "https://apivucem.econnectpro.mx/datastage/get_layout_contribuciones/")
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.consulta.items = res.data;
                        this.consulta.items.sort(function (a, b) {
                            //Ordenar por fecha más reciente
                            return new Date(b.fecha) - new Date(a.fecha);
                        });
                        for (var k in this.consulta.items) {
                            this.consulta.items[k].fecha = this.parseDate(this.consulta.items[k].fecha);
                        }
                    }
                })
                .catch(err => {

                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        get_array_lista: function (cadena) {
            try {
                var newarr = [];
                if (cadena != undefined) {
                    let data = cadena.split("\n");
                    newarr = data.filter(a => a.trim() !== '');
                    for (var i = 0; i < newarr.length; i++) {
                        newarr[i] = newarr[i].trim();
                        newarr[i] = newarr[i].replace(',', '');
                        newarr[i] = newarr[i].replace('.', '');
                    }
                }
                return newarr;
            } catch (error) {
                console.log(error);
            }
        },
        download_layout: function (key) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                id: key,
                bucket: "descargas.econnectpro.mx"
            }
            let nombre_download = key.split("/").pop();
            axios.post(this.$hostname + "s3/download/", datos, {
                    "Content-type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    Allow: "POST",
                    "cache-control": "no-cache",
                })
                .then(response => {
                    var bytes = this.base64ToArrayBuffer(response.data);
                    let blob = new Blob([bytes], {
                            type: response.headers["content-type"]
                        }),
                        url = window.URL.createObjectURL(blob);

                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display: none";
                    a.href = url;
                    a.download = nombre_download;
                    a.click();
                    a.parentNode.removeChild(a);
                })
                .catch(error => {
                    console.log(error);

                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });

        },
        base64ToArrayBuffer: function (base64) {
            var binaryString = window.atob(base64);
            var binaryLen = binaryString.length;
            var bytes = new Uint8Array(binaryLen);
            for (var i = 0; i < binaryLen; i++) {
                var ascii = binaryString.charCodeAt(i);
                bytes[i] = ascii;
            }
            return bytes;
        },
        verificaTipoOperacion: function () {
            if (this.model.opc_impo != 1 && this.model.opc_expo != 1) {
                return "Seleccione al menos un tipo de operación";
            }
            return true;
        },
        verificaPedimento: function () {
            if (this.model.lista != '' && this.model.lista != null && this.model.lista.length > 0) {
                return true;
            }
            if (this.model.fecha_de == "" || this.model.fecha_a == "") {
                return "Favor de ingresar fechas o listado de pedimentos";
            }
            return true;
        },
        maxListaRule: function () {
            if (this.model.lista == '' || this.model.lista == undefined || Array.isArray(this.model.lista)) {
                return "Lista vacia";
            }

            let x = this.model.lista.split("\n");

            if (x.length > 50) {
                return "No se puede consultar mas de 50 pedimentos";
            } else if (x.length > 0) {
                for (var k in x) {
                    if (!this.validarPatronPedimento(x[k]))
                        return "Verificar pedimentos no válidos. Ejemplo correcto: 240-0123-0000123";
                }
            }

            return true;
        },
        validarPatronPedimento(pedimento) {
            const patternPedimento = /^[0-9]{3}-{1}[0-9]{4}-{1}[0-9]{7}$/;
            return patternPedimento.test(pedimento);
        },
        validaFecha: function (fecha) {
            if (fecha == "Invalid date")
                return "Fecha no válida.";
            else
                return true;
        },
        validaAnio: function () {
            if (this.model.fecha_de != "" && this.model.fecha_a != "") {
                var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
                var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
                var diferencia = fin.diff(inicio, 'days')
                if (diferencia < 0)
                    return "La Fecha Final no debe ser menor a la Fecha Inicial."
            }
            return true;
        },

        cargarReportesDS: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let data = {
                rfc: this.model.rfc,
                "tipo": "Layout_Contribuciones"
            };
            axios.post(this.URL + "get_reportes/", data)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.datos = res.data;
                        this.datos.sort(function (a, b) {
                            //Ordenar por fecha más reciente
                            return new Date(b.fecha_solicitud) - new Date(a.fecha_solicitud);
                        });
                        for (var k in this.datos) {
                            this.datos[k].fecha_solicitud = this.parseDate(this.datos[k].fecha_solicitud);
                            this.datos[k].fecha_generacion = this.parseDate(this.datos[k].fecha_generacion);
                            this.datos[k].estatus = this.getEstatus(this.datos[k].estatus);
                            this.datos[k].criterio = this.getCriterioPredeterminadosDS(this.datos[k].criterio);
                        }
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los reportes ds.",
                        footer: ""
                    });
                    console.log(err);

                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },

        getEstatus: function (estatus) {
            var arr_estatus = ["Pendiente", "Encolado", "Generado Correctamente", "Con Errores"];
            if (estatus in arr_estatus)
                return arr_estatus[estatus];
            else
                return "N/A";
        },
        getCriterioPredeterminadosDS: function (criterio) {
            try {
                if (criterio != undefined && criterio.toString().trim() != "") {
                    var params = JSON.parse(criterio);
                    var result = "";

                    if (params.lista != undefined && params.lista != "" && params.lista.length > 0) {
                        result += "Búsqueda por Lista.";
                    } else {
                        result += "Fecha De: " + params.fecha_de + ", " + "Fecha A: " + params.fecha_a;
                    }

                    if (params.rfc_cliente != undefined && params.rfc_cliente != "")
                        result += ", RFC: " + params.rfc_cliente;

                    return result;
                } else {
                    return "N/A";
                }
            } catch (error) {
                console.log(error);
                return "N/A-error";
            }
        },

        generar_reporte_sqs() {
            if (!this.$refs.form.validate()) {
                console.log("Datos: ", this.model);
                //Alguna operación o mensaje
            } else {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                var data = Vue.util.extend({}, this.model); //Clonamos el modelo, para no desagrupar los filtros de contribuciones

                if (data.lista == '' || data.lista == []) {
                    delete(data['lista']);
                } else {
                    data['lista'] = this.get_array_lista(data['lista']);
                    data['fecha_de'] = ""
                    data['fecha_a'] = ""
                }

                data["id_reporte"] = 90090900;

                axios({
                        method: "post",
                        url: this.$hostname + "reportes/save_reporte/",
                        //url: "http://127.0.0.1:7000/reportes_ds/contribuciones_partidas/",
                        data: data
                    })
                    .then(response => {
                        this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El reporte se está generando. Cuando esté listo recibirá una notificación",
                            footer: ""
                        });
                    })
                    .catch(error => {
                        let mensaje;
                        var titulo = "¡Operación no Permitida!";
                        var tipo = "error";
                        if (typeof error.response !== "undefined") {
                            mensaje = error.response.data.mensaje;
                            if (error.response.status == 406) {
                                titulo = "¡Ya existe un reporte en proceso!";
                                tipo = "info";
                            }
                        } else {
                            mensaje = "Ocurrió un error al generar el reporte";
                        }
                        this.$swal({
                            type: tipo,
                            title: titulo,
                            text: mensaje,
                            footer: ""
                        });
                        this.$root.$dialogLoader.hide();
                    }).then(() => {
                        this.model.lista = '';
                        this.lista_filtrada = [];
                        this.cargarReportesDS();
                    });
            }
        },

        parseDate(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD");
        },
        parseDateTime(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD HH:mm:ss");
        },
        setNombreReporte: function () {
            var url = this.model.reporte_url
            var search = this.list_reportes.filter(function (e) {
                return e.url == url;
            });
            if (search.length > 0) {
                this.model.nombre_reporte = search[0].reporte;
            }
        },
        downloadFile: function (key) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                id: key,
                bucket: "production.econnect.ds"
            }
            axios.post(this.$hostname + 's3/download_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = res.data.mensaje;
                        a.target = "_blank";
                        a.click();
                        a.parentNode.removeChild(a);

                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        eliminarReporte: function (idreporte) {
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar el reporte con No. Proceso: " + idreporte + "?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(result => {
                if (result.value) {
                    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                    var datos = {
                        id_reporte: idreporte,
                    }
                    axios.post(this.$hostname + 'reportes/eliminar_reporte/', datos)
                        .then((res) => {
                            this.$swal({
                                type: "success",
                                title: "Operación Exitosa",
                                text: "El reporte se eliminó correctamente",
                                footer: ""
                            });
                        })
                        .catch((error) => {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al eliminar el reporte. Favor de comunicarse con soporte.",
                                footer: '',
                            });
                            console.log(error);
                        }).then(() => {
                            this.$root.$dialogLoader.hide();
                            this.cargarReportesDS();
                        });
                }
            });
        },
        get_rfcs() {
            axios.post("https://apireportes.econnectpro.mx/reportes_ds/get_rfcs_contribuciones/")
                .then(response => {
                    this.rfcs_array = response.data;
                    this.rfcs_array.sort();
                }).catch(error => {
                    console.log(error);
                }).then(() => {
                    this.show_combo_rfc = true;
                });
        },
        guardar() {
            var self = this;
            self.errorMsg = "";
            self.successMsg = "";
            var user = this.$local_storage.get("id_usuario").toString().trim();
            self.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            

            const name = user + '_' + Math.ceil(Math.random() * 1000000) + '.xlsx'
            var keyBucket =  "CONTRIBUCIONES_TMP/" + name;
            var datos = {
                key: keyBucket,
                bucket: "production.econnect.ds",
                type: self.elzip.type
            }

             axios.post(self.$hostname + 's3/upload_url/', datos)
                .then(async (res) => {
                    self.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                    if (typeof res.data !== 'undefined') {
                        var urlput = res.data.mensaje;

                        await axios.put(urlput, self.elzip, {
                                headers: {
                                    'Content-Type': self.elzip.type
                                }
                            })
                            .then(async (res) => {

                                let formData = {};

                                formData = {
                                    key: keyBucket,
                                    usuario: self.$local_storage.get("id_usuario")
                                };

                                 self.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

                                        await axios.post('https://apivucem.econnectpro.mx/datastage/guardar_layout_contribuciones/', formData)
                                            .then((res) => {
                                                console.log(res);
                                                this.$swal({
                                                    type: "success",
                                                    title: "¡Operación Terminada!",
                                                    text: "El archivo se envio a procesar correctamente."
                                                });
                                                self.get_rfcs();
                                                self.cargarConsultas();
                                                self.$root.$dialogLoader.hide();
                                            }).catch((error) => { //ya que si el archivo es muy grande recibirá un timeOut, igualmente recibirá notificación al terminar de cargarse
                                                var mensaje = "Ocurrió un error al cargar el archivo. Favor de intentarlo de nuevo más tarde.";
                                                self.errorMsg += mensaje;
                                                self.$root.$dialogLoader.hide();
                                                this.$swal({
                                                    type: "error",
                                                    title: "¡Operación no Permitida!",
                                                    text: mensaje
                                                });
                                            });
                            }).catch((error) => {

                                self.$root.$dialogLoader.hide();

                                var mensaje = "Ocurrió un error al cargar el archivo. Favor de intentarlo de nuevo más tarde.";
                               
                                this.$swal({
                                                    type: "error",
                                                    title: "¡Operación no Permitida!",
                                                    text: mensaje
                                                });

                            });
                       
                    } else {

                        self.$root.$dialogLoader.hide();
                        var mensaje = "Ocurrió un error al cargar el archivo. Favor de intentarlo de nuevo más tarde.";
                        this.$swal({
                                                    type: "error",
                                                    title: "¡Operación no Permitida!",
                                                    text: mensaje
                                                });
                        //    self.errores_excel.push({'archivo': x[1].name, "error": mensaje});

                    }
                }).catch((error) => {
                    self.$root.$dialogLoader.hide();
                    var mensaje = "Ocurrió un error al cargar el archivo. Favor de intentarlo de nuevo más tarde.";
                    this.$swal({
                                                    type: "error",
                                                    title: "¡Operación no Permitida!",
                                                    text: mensaje
                                                });
                    

                });

            //self.removeItems();

            //console.log("Intento:",intento);

        },
        handleSuccess: function ({
            results,
            header
        }) {
            var errores = 0;
            var erroresText = '';
            let self = this;
            
            try {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                self.guardar();

            } catch (error) {
                this.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al cargar el archivo. Verifique que no existan celdas vacías."
                });
               
            }
        },

        beforeUpload(file) {
            
            const isLt20M = file.size / 1024 / 1024 < 20;
            let self = this;
            
            if (isLt20M) {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                self.elzip = file
                return true;
            }
            this.$swal({
                type: "warning",
                title: "¡Operación no Permitida!",
                text: "El archivo no debe ser mayor a 20MB.",
                footer: ""
            });
            return false;
        },
    }, //methods
};
</script>

<style scoped>
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled {
    color: black;
    font-size: small;
    background-color: #EEEEEE;
    padding: 0px;
}

.v-tabs .v-tabs-bar .v-tab.v-tab--active {
    color: white;
    font-size: small;
    background-color: #df7205;
    padding: 0px;
    font-weight: bold;

}

.v-tabs-slider-wrapper {
    left: 0 !important;
}

.elevation-1>>>#VueTables_th--Referencia {
    min-width: 350px !important;
}

.elevation-2>>>#VueTables_th--localizado {
    min-width: 450px !important;
}

.elevation-2>>>.columnaCriterio {
    white-space: normal !important;
    max-width: 450px !important;
    text-align: justify !important;
}
</style>
